import { defineMessages } from "@/i18n";
import en from "./en";

export const updatesMessages = defineMessages("updates", en);
